import { render } from "./index.vue?vue&type=template&id=39911564"
import script from "./game-summary.ts?vue&type=script&lang=js"
export * from "./game-summary.ts?vue&type=script&lang=js"

import "./game-summary.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script